  import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
  import {Observable} from "rxjs";
  import {
    DashboardStatisticFilterEnum,
  DashboardStatisticItem,
  RecentlyCreatedOrModifiedItems
} from "../../shared/models/dashboard.model";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  getRecentActivity(): Observable<RecentlyCreatedOrModifiedItems[]> {
    return this.http.get<RecentlyCreatedOrModifiedItems[]>(this.brennerSoftwareApiEndpoint + `dashboard/recentActivity`);
  }

  getDashboardStatistics(filterItem: DashboardStatisticFilterEnum): Observable<DashboardStatisticItem> {
    return this.http.get<DashboardStatisticItem>(this.brennerSoftwareApiEndpoint + `dashboard/statistics/${filterItem}`);
  }
}
